// Re-observe on tab activation so a stale intersection from the background
// cannot start the map after the layout or scroll position has changed.
export default function observeVisibleMap(target, onVisible) {
  const minimumVisibleRatio = 0.01;
  let stopped = false;
  const observer = new IntersectionObserver(entries => {
    const entry = entries[entries.length - 1];
    if (!stopped && document.visibilityState === 'visible' &&
        entry && entry.isIntersecting && entry.intersectionRatio >= minimumVisibleRatio) {
      onVisible();
    }
  }, { threshold: minimumVisibleRatio });

  const observeInForeground = () => {
    observer.disconnect();
    observer.takeRecords();
    if (document.visibilityState === 'visible') {
      observer.observe(target);
    }
  };

  document.addEventListener('visibilitychange', observeInForeground);
  observeInForeground();

  return () => {
    stopped = true;
    observer.disconnect();
    document.removeEventListener('visibilitychange', observeInForeground);
  };
}
